<template>
  <div class="content conta">
    <h1><span><i class="fas fa-user-circle"></i> Conta</span></h1>

    <b-tabs pills nav-class="mb-5 mt-5" lazy>
      <b-tab title="Perfil"  @click="changeRouter('perfil')" :active="isActive('perfil')" v-if="false">
        <conta-perfil />
      </b-tab>
      <b-tab title="Dados contratuais" @click="changeRouter('dados-contratuais')" :active="isActive('dados-contratuais')" v-if="false">
        <conta-dados-contratuais />
      </b-tab>
      <b-tab title="Usuários" @click="changeRouter('usuarios')" :active="isActive('usuarios')">
        <conta-usuarios />
      </b-tab>
      <b-tab title="Configurações" @click="changeRouter('configuracoes')" :active="isActive('configuracoes')" v-if="false">
        <conta-configuracoes />
      </b-tab>
      <b-tab title="Turmas" @click="changeRouter('turmas')" :active="isActive('turmas')">
        <lista-turmas />
      </b-tab>
      <b-tab title="Tutores" @click="changeRouter('tutores')" :active="isActive('tutores')">
        <lista-tutores />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import ContaPerfil from '@/modules/Conta/components/ContaPerfil'
import ContaDadosContratuais from '@/modules/Conta/components/ContaDadosContratuais'
import ContaUsuarios from '@/modules/Conta/components/ContaUsuarios'
import ContaConfiguracoes from '@/modules/Conta/components/ContaConfiguracoes'
import ListaTurmas from '@/modules/Conta/components/ListaTurmas'
import ListaTutores from '@/modules/Conta/components/ListaTutores'

export default {
  name: 'ContaView',
  components: { ContaConfiguracoes, ContaUsuarios, ContaDadosContratuais, ContaPerfil, ListaTutores, ListaTurmas },

  methods: {
    isActive: function (tab) {
      return this.$route.params.activeTab === tab
    },

    changeRouter: function (tab) {
      this.$router.push(`/conta/${tab}`)
    }
  }
}
</script>

<style scoped>

</style>
